
export default {
    name: 'LeeSelect',
    inheritAttrs: false,
    data() {
        return {
            nodata: false,//這個數據是為了搜索沒數據時提示沒有數據
            lists: [], //重新整合數組
            exp: false,
            isReadonly: false,
            search: '', //input LABEL值
            placeh: '' //INPUT替代文本
        }
    },
    beforeDestroy() {
        document.removeEventListener('click', function() {
            _this.exp = false
        });
    },
    mounted() {
        var _this = this
        document.addEventListener('click', function() {
            _this.exp = false
        });
        var slots = this.$slots.default
        slots.map(function(el) {
            _this.lists.push({
                value: el.child.value,
                label: el.child.label
            })
        })
    },
    provide() {
        return {
            select: this
        };
    },
    methods: {
        expcl() {
            var children = this.$parent.$children
            var _this = this
            var fi = children.filter(function(el) {
                var tag = el.$vnode.tag
                return tag.indexOf('LeeSelect') > -1
            });
            fi.map(function(el) {
                if (!_this.exp) {
                    el.exp = false
                    _this.exp = true
                } else {
                    _this.exp = false
                    el.exp = false
                }
            })
        }
    },
    computed: {
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        filterable: {
            type: Boolean,
            default: false
        }
    },
    watch: {
         exp: {
            immediate: true,
            handler(value) {
                this.$nextTick(function() {
                    if (this.filterable) {
                        if (value) {
                            if (this.search == '') {
                                this.placeh = this.placeholder
                                return
                            }
                            this.placeh = this.search
                            this.search = ''
                        }
                    }
                })
            }
        },
        filterable: {
            immediate: true,
            handler(value) {
                this.isReadonly = !value
            }
        },
        placeholder: {
            immediate: true,
            handler(value) {
                this.placeh = value
            }
        },
        search: {
            immediate: true,
            handler(value) {
                var _this = this
                this.$nextTick(function() {
                    var fi = this.lists.filter(function(el) {
                        return el.label.toLowerCase().indexOf(value.toLowerCase()) > -1;
                    });
                   if(fi.length>0){
                    _this.nodata=false
                   }else{
                    _this.nodata=true
                   }
                })
            }
        },
        value: {
            immediate: true,
            handler(value) {
                var _this = this
                this.$nextTick(function() {
                    var fi = _this.lists.filter(function(el) {
                        return el.value == value;
                    });
                    if (fi.length > 0) {
                        _this.search = fi[0].label
                    } else {
                        _this.search = ''
                    }
                })
            }
        }
    }
};
